import {
  GET_APP_LIST,
  APP_LIST,
  SAVE_APP,
  APP_REGISTER_SUCCESS,
  APP_MESSAGE,
  DELETE_APP,
  APP_DATA,
  GET_PUBLISHED_APP_LIST,
  PUBLISHED_APP_LIST,
  GET_SUBSCRIBED_APP_LIST,
  SUBSCRIBED_APP_LIST,
  GET_MENU_APP_LIST,
  MENU_APP_LIST,
  DEVELOPER_APP,
  GET_MFA_SETUP_HOME_SUCCESS,
  USING_2FA,
  TOGGLE_2FA,
  APP_PERMISSION_LIST,
  APP_ROLE_LIST,
  APP_ROLE_PERMISSION_LIST,
  SET_ADD_EDIT,
  APP_SETTINGS_JSON,
  ADD_APP_SETTINGS_JSON,
  GET_APP_SETTINGS_DETAILS,
  APP_INSTANCE_DATA,
  SHOW_LOADING,
  HIDE_LOADING,
  UI_PROPERTIES_JSON,
  APP_UI_PROPERTIES,
  ADD_APP_UI_PROPERTIES,
  EDIT_APP_UI_PROPERTIES,
  DELETE_APP_UI_PROPERTIES,
  ACCOUNT_USER_APP_INSTANCE_ROLES,
} from "redux/constants/app";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const initState = {
  loading: true,
  apps: [],
  publishedApps: [],
  subscribedApps: [],
  menuApps: { content: [], totalElements: 0 },
  publishedListType: null,
  subscribedListType: null,
  publishedAppsLoaded: false,
  subscribedAppsLoaded: false,
  developerAppsListType: null,
  developerAppsLoaded: false,
  appPermissions: [],
  appRolePermissions: [],
  appRoles: [],
  uiPropertiesJsonData: [],
  accountUserRoles:[],
  developerApp: {},
  app: {},
  message: "",
  showMessage: false,
  using2fa: false,
  twoFactorLoading: false,
  redirect: "",
  allowRedirect: false,
  status: 0,
  addEditValue: false,
  permissions : localStorage.getItem("permissions")!==""?JSON.parse(localStorage.getItem("permissions")):"",
};

const app = (state = initState, action) => {
  switch (action?.type) {
    case GET_APP_LIST: {
      const nextType = action?.requestData?.type;
      return {
        ...state,
        loading: true,
        developerAppsLoaded: false,
        developerAppsListType: nextType || state.developerAppsListType,
        apps: [],
      };
    }
    case APP_LIST:
      return {
        ...state,
        apps: action.apps,
        developerAppsLoaded: true,
        developerAppsListType: action.listType ?? state.developerAppsListType,
        allowRedirect: false,
        loading: false,
        message: "",
        addEditValue:false
      };
    case GET_PUBLISHED_APP_LIST: {
      const nextType = action?.payload?.type;
      const shouldResetList = nextType && nextType !== state.publishedListType;
      return {
        ...state,
        loading: true,
        publishedAppsLoaded: false,
        publishedListType: nextType || state.publishedListType,
        publishedApps: shouldResetList ? [] : state.publishedApps,
      };
    }
    case PUBLISHED_APP_LIST:
      return {
        ...state,
        publishedApps: action.publishedApps,
        publishedAppsLoaded: true,
        allowRedirect: false,
        loading: false,
        message: "",
      };
    case GET_SUBSCRIBED_APP_LIST: {
      const nextType = action?.requestData?.type;
      const shouldResetList = nextType && nextType !== state.subscribedListType;
      return {
        ...state,
        loading: true,
        subscribedAppsLoaded: false,
        subscribedListType: nextType || state.subscribedListType,
        subscribedApps: shouldResetList ? [] : state.subscribedApps,
      };
    }
    case SUBSCRIBED_APP_LIST:
      return {
        ...state,
        subscribedApps: action.subscribedApps,
        subscribedAppsLoaded: true,
        loading: false,
        allowRedirect: false,
        message: "",
      };
    case GET_MENU_APP_LIST:
      return {
        ...state,
        menuAppsLoading: true,
      };
    case MENU_APP_LIST:
      return {
        ...state,
        menuApps: action.menuApps,
        menuAppsLoading: false,
      };
    case DEVELOPER_APP:
      return {
        ...state,
        developerApp: action.developerApp,
        allowRedirect: false,
        loading: false,
        message: "",
      };
    case APP_DATA:
      return {
        ...state,
        app: action.app,
        loading: false,
        allowRedirect: false,
        message: "",
      };
    case APP_MESSAGE:
      return {
        ...state,
        message: messageRead(action),
        app:action?.response?.data,
        status: action?.response?.status,
        showMessage: true,
        loading: false,
        twoFactorLoading: false,
        developerAppsLoaded: true,
        addEditValue: false
      };
    case USING_2FA:
      return {
        ...state,
        twoFactorLoading: true,
      };
    case GET_MFA_SETUP_HOME_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action?.data?.message,
        mfaCode: action?.data?.mfaCode,
        qrCode: action?.data?.qrCode,
        showMessage: true,
        twoFactorLoading: false,
      };
    case APP_REGISTER_SUCCESS:
      return {
        ...state,
        message: messageRead(action),
        status: action?.response?.status,
        app:action?.response?.data,
        showMessage: true,
        loading: false,
        allowRedirect: true,
        redirect: `${APP_PREFIX_PATH}/${localStorage.getItem(
          "accountId"
        )}/developer-app`,
      };
    case TOGGLE_2FA: {
      return {
        ...state,
        loading: false,
        using2fa: action.using2fa,
        twoFactorLoading: action.using2fa ? state.twoFactorLoading : false,
      };
    }
    case APP_PERMISSION_LIST:
      return {
        ...state,
        appPermissions: action.appPermissions,
        loading: false,
        allowRedirect: false,
        message: "",
      };
    case APP_ROLE_LIST:
      return {
        ...state,
        appRoles: action.appRoles,
        loading: false,
        allowRedirect: false,
        message: "",
      };
    case APP_ROLE_PERMISSION_LIST:
      return {
        ...state,
        appRolePermissions: action.appRolePermissions,
        loading: false,
        allowRedirect: false,
        message: "",
      };
    case ACCOUNT_USER_APP_INSTANCE_ROLES:
      return {
        ...state,
        accountUserRoles: action.accountUserRoles,
        allowRedirect: false,
        message: "",
      }
    case SHOW_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case HIDE_LOADING: {
      return {
        ...state,
        loading: false,
      };
    }
    case SET_ADD_EDIT:
      return {
        ...state,
        addEditValue: action.addEditValue,
        appRolePermissions: action.addEditValue ? state.appRolePermissions : [],
      };
    case APP_SETTINGS_JSON:
      return {
        ...state,
        appSettingsJson: action.appSettingsJson,
        loading: false,
        message: "",
      };
    case ADD_APP_SETTINGS_JSON:
      return {
        ...state,
        loading: true,
        resData: {},
      };

    case GET_APP_SETTINGS_DETAILS:
      return {
        ...state,
        loading: true,
        resData: {},
      };
    case APP_INSTANCE_DATA:
      return {
        ...state,
        loading: false,
        app: action.appInstanceData,
      };
    case APP_UI_PROPERTIES:
      return { ...state, loading: false, resData: {} };
    case ADD_APP_UI_PROPERTIES:
      return { ...state, loading: false, resData: {} };
    case EDIT_APP_UI_PROPERTIES:
      return { ...state, loading: false, resData: {} };
    case DELETE_APP_UI_PROPERTIES:
      return { ...state, loading: false, resData: {} };
      case UI_PROPERTIES_JSON:
      return {
        ...state,
        uiPropertiesJsonData: action.uiPropertiesJsonData,
        loading: false,
        message: "",
      };
    default:
      return state;
  }
};

const messageRead=(action)=>{
  if(action?.response?.status===401 || action?.response?.response?.status){
    return "Unauthorized"
  }
  if(action?.response?.status===200){
    return "Success"
  }
	if(action?.response && action?.response?.response && action?.response?.response?.data && action?.response?.response?.message){
	 return action?.response?.response?.data?.message;
	}else if(action?.response && action?.response?.data && action?.response?.data?.message){
		return action?.response?.data?.message;
	}else if(action?.response && action?.response?.data && action?.response?.data?.message){
		return action?.response?.data?.message;
	}else if(action?.data?.message){
		return action?.data?.message;
	}else if(action?.data){
		return action?.data;
	}else{
		return "something went wrong"
	}
}

export default app;
